"use client";

import { size, theme } from "@/config/theme";
import { breakpoints } from "@/utils/breakpoint";
import { SCContainerContent } from "@/utils/styledComponents";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import styled from "styled-components";

const OurStoryOurMission = () => {
    const t = useTranslations("OurStoryOurMission");
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        <SCOurStoryOurMission>
            <SCOurStoryOurMissionContent>
                {isClient && (
                    <video className="tss-video" controls playsInline>
                        <source
                            src="https://www.dropbox.com/scl/fi/dv9eut4p8avu7jemc73uh/The-Swim-Starter_16x9_Draft-3.mp4?rlkey=qcih5hw0sq91mvxil7q5kpvp7&st=pfva6c89&dl=1"
                            type="video/mp4"
                        />
                        Your browser does not support the video tag.
                    </video>
                )}
                <div className="text-containers-container">
                    <div className="text-container">
                        <div className="text-largexlarge">
                            {t("ourStory-title-text")}
                        </div>
                        <div className="text-medium">
                            {t("ourStory-description-text")}
                        </div>
                    </div>
                    <div className="text-container">
                        <div className="text-largexlarge">
                            {t("ourMission-title-text")}
                        </div>
                        <div className="text-medium">
                            {t("ourMission-description-text")}
                        </div>
                    </div>
                </div>
            </SCOurStoryOurMissionContent>
        </SCOurStoryOurMission>
    );
};

export default OurStoryOurMission;

const SCOurStoryOurMission = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: ${theme["spacing-lxl"]} 0;
`;

const SCOurStoryOurMissionContent = styled(SCContainerContent)`
    .tss-video {
        width: 100%;
        margin-bottom: ${theme["spacing-l"]};
    }

    .text-containers-container {
        display: flex;
        flex-direction: row;

        // Mobile view
        ${breakpoints(
            "flex-direction",
            "",
            [{ [size.px.sxs]: "column" }],
            "max-width"
        )};

        .text-container {
            margin-right: ${theme["spacing-lxl"]};
            ${breakpoints(
                "margin-bottom",
                "px",
                [{ [size.px.sxs]: "40" }],
                "max-width"
            )};

            &:last-child {
                margin-right: 0;
                margin-bottom: 0;
            }

            .text-largexlarge {
                font-size: ${theme["fontsize-lxl"]};
                font-weight: 500;
                margin-bottom: ${theme["spacing-m"]};
            }

            .text-medium {
                font-size: ${theme["fontsize-m"]};
                color: ${theme["color-grey"]};
                line-height: 2;
            }
        }
    }
`;
